import { render } from "./myselect.vue?vue&type=template&id=0dab66e8&scoped=true"
import script from "./myselect.vue?vue&type=script&lang=js"
export * from "./myselect.vue?vue&type=script&lang=js"

import "./myselect.vue?vue&type=style&index=0&id=0dab66e8&lang=scss&scoped=true"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dab66e8"]])

export default __exports__